import type { DropDownResult, ModalDialogButtonSetting, OdinDataRetrievalOptions } from '@myosh/odin-components';
import { Dialog } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { submitExportFullRecords } from '../../../../redux/slices/background-job-slice';
import { selectedGlobalHierarchies, selectedMatchingOption } from '../../../../redux/slices/global-hierarchies';
import { buildGlobalHierarchyFiltersUrl } from '../../../../utils/filter-url-builder-utils';

interface ExportRecordListTemplatesModalProps {
  visible: boolean;
  onClose: () => void;
  selectedForm?: DropDownResult;
  columns?: string;
  gridOptions?: OdinDataRetrievalOptions;
}

const ExportRecordListTemplatesModal = ({
  selectedForm,
  columns,
  gridOptions,
  visible,
  onClose,
}: ExportRecordListTemplatesModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const globalFilters = useAppSelector(selectedGlobalHierarchies);
  const globalFiltersMatchingOption = useAppSelector(selectedMatchingOption);

  const buttons: ModalDialogButtonSetting[] = [
    { text: t('no'), name: 'no', onClick: () => handleTemplateDownloadByFormat('TEMPLATE'), closeModalOnClick: true },
    {
      text: t('yes'),
      name: 'yes',
      type: 'primary',
      onClick: () => handleTemplateDownloadByFormat('TEMPLATE_AND_RECORDS'),
      closeModalOnClick: true,
    },
  ];

  const handleTemplateDownloadByFormat = (format: 'TEMPLATE' | 'TEMPLATE_AND_RECORDS') => {
    dispatch(
      submitExportFullRecords({
        exportFullRecordData: true,
        format,
        formId: selectedForm?.value as string,
        formName: selectedForm?.text as string,
        columns,
        gridOptions,
        globalHierarchyFilters: buildGlobalHierarchyFiltersUrl(globalFilters, globalFiltersMatchingOption),
      })
    );
  };

  return (
    <>
      {visible && (
        <Dialog visible={visible} onClose={onClose} buttons={buttons}>
          <h3>{t('export-record-template-text')}</h3>
        </Dialog>
      )}
    </>
  );
};

export default ExportRecordListTemplatesModal;
